import { Component, OnInit } from '@angular/core';
import { FavoriteService } from 'src/app/services/favorite.service';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CookieService } from '../../../../node_modules/ngx-cookie-service';

@Component({
  selector: 'app-favorite',
  templateUrl: './favorite.component.html',
  styleUrls: ['./favorite.component.scss']
})
export class FavoriteComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  filterFundList: any = ''
  filterFundList2: any = ''
  filterFundList3: any = ''
  filterFundList4: any = ''
  filterFundList5: any = ''
  filterFundList6: any = ''
  filterFundList7: any = ''
  filterFundList8: any = ''
  filterFundList9: any = ''
  filterFundList10: any = ''
  filterFundList11: any = ''
  filterFundList12: any = ''
  filterFundList13: any = ''
  filterFundList14: any = ''
  filterFundList15: any = ''
  filterFundList16: any = ''
  filterFundList17: any = ''
  emptyFav: boolean

  constructor(private _Service: FavoriteService, private http: HttpClient,
    private ngxService: NgxUiLoaderService,
    private cookieService: CookieService) { }

  ngOnInit() {
    this.ngxService.start();
    // this.http.get<{ ip: string }>('https://jsonip.com').subscribe(data => {

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "1").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList = response
      }
      else {
        this.filterFundList = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "2").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList2 = response
      }
      else {
        this.filterFundList2 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "3").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList3 = response
      }
      else {
        this.filterFundList3 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "4").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList4 = response
      }
      else {
        this.filterFundList4 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "6").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList5 = response
      }
      else {
        this.filterFundList5 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "7").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList6 = response
      }
      else {
        this.filterFundList6 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "8").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList7 = response
      }
      else {
        this.filterFundList7 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "10").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList8 = response
      }
      else {
        this.filterFundList8 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "13").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList9 = response
      }
      else {
        this.filterFundList9 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "12").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList10 = response
      }
      else {
        this.filterFundList10 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "11").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList11 = response
      }
      else {
        this.filterFundList11 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "15").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList12 = response
      }
      else {
        this.filterFundList12 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "14").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList13 = response
      }
      else {
        this.filterFundList13 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "9").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList14 = response
      }
      else {
        this.filterFundList14 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "16").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList15 = response
      }
      else {
        this.filterFundList15 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "17").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList17 = response
      }
      else {
        this.filterFundList17 = ""
      }
    })

    this._Service.Post_get_fund_ByFAV(localStorage.getItem('uuid_'), "5").subscribe(response => {
      if (response[0]["FundId"] != "") {
        this.filterFundList16 = response
      }
      else {
        this.filterFundList16 = ""
      }


      if (this.filterFundList == "" && this.filterFundList2 == "" && this.filterFundList3 == "" && this.filterFundList4 == ""
        && this.filterFundList5 == "" && this.filterFundList6 == "" && this.filterFundList7 == "" && this.filterFundList8 == ""
        && this.filterFundList9 == "" && this.filterFundList10 == "" && this.filterFundList11 == "" && this.filterFundList12 == ""
        && this.filterFundList13 == "" && this.filterFundList14 == "" && this.filterFundList15 == "" && this.filterFundList16 == ""
        && this.filterFundList17 == "") {
        this.emptyFav = true;
      }
      else {
        this.emptyFav = false;

      }


    })
    this.ngxService.stop();

    // })

  }

}
